import { Pencil, Power, RotateCcw, Trash2 } from 'lucide-react';

const STATUS = {
  running: { label: 'En cours', cls: 'text-emerald-300 border-emerald-500/40 bg-emerald-500/10' },
  scheduled: { label: 'À venir', cls: 'text-blue-300 border-blue-500/40 bg-blue-500/10' },
  ended: { label: 'Terminée', cls: 'text-zinc-400 border-white/10 bg-white/5' },
  inactive: { label: 'Désactivée', cls: 'text-amber-300 border-amber-500/40 bg-amber-500/10' },
};
const fmt = (d) => new Date(d).toLocaleDateString('fr-FR');

export const PromotionList = ({ promos, onEdit, onToggle, onRelaunch, onDelete }) => {
  if (promos.length === 0) {
    return (
      <p className="text-zinc-500 text-sm border border-white/10 p-10 text-center" data-testid="promo-empty">
        Aucune promotion. Créez-en une pour déstocker une sélection de parfums.
      </p>
    );
  }
  return (
    <ul className="space-y-3" data-testid="promo-list">
      {promos.map(p => {
        const st = STATUS[p.status] || STATUS.ended;
        return (
          <li key={p.id} className="border border-white/10 bg-[color:var(--color-surface)] p-4 flex flex-col md:flex-row md:items-center gap-4" data-testid={`promo-row-${p.id}`}>
            <div className="flex-1 min-w-0">
              <div className="flex flex-wrap items-center gap-2">
                <p className="text-white text-lg" style={{ fontFamily: 'Cormorant Garamond, serif' }}>{p.name}</p>
                <span className={`text-[10px] uppercase tracking-wider px-2 py-0.5 border ${st.cls}`} data-testid={`promo-status-${p.id}`}>{st.label}</span>
              </div>
              <p className="text-zinc-500 text-xs mt-1">
                Du {fmt(p.starts_at)} au {fmt(p.ends_at)} · {p.items?.length || 0} produit(s)
              </p>
            </div>
            <div className="flex flex-wrap gap-2">
              <button type="button" onClick={() => onEdit(p.id)} className="inline-flex items-center gap-1.5 px-3 py-1.5 border border-white/10 text-zinc-300 hover:text-white text-sm" data-testid={`promo-edit-${p.id}`}>
                <Pencil className="w-3.5 h-3.5" /> Modifier
              </button>
              <button type="button" onClick={() => onToggle(p)} className="inline-flex items-center gap-1.5 px-3 py-1.5 border border-white/10 text-zinc-300 hover:text-white text-sm" data-testid={`promo-toggle-${p.id}`}>
                <Power className="w-3.5 h-3.5" /> {p.active ? 'Désactiver' : 'Activer'}
              </button>
              {(p.status === 'ended' || p.status === 'inactive') && (
                <button type="button" onClick={() => onRelaunch(p)} className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-[color:var(--color-primary)] text-black hover:bg-[color:var(--color-primary-hover)] text-sm" data-testid={`promo-relaunch-${p.id}`}>
                  <RotateCcw className="w-3.5 h-3.5" /> Relancer 14 j
                </button>
              )}
              <button type="button" onClick={() => onDelete(p)} className="p-2 text-zinc-500 hover:text-red-400" title="Supprimer" data-testid={`promo-delete-${p.id}`}>
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
          </li>
        );
      })}
    </ul>
  );
};
